/** Single delegated touchstart (iOS :active on buttons); replaces per-button listeners. */
const onDocumentTouchStartCapture = function(e) {
  const t = e.target;
  if (t && typeof t.closest === 'function' && t.closest('button')) {
    /* intentional noop */
  }
};

const init = () => {
  window.onload = function() {
    if (/iP(hone|ad)/.test(window.navigator.userAgent)) {
      document.addEventListener('touchstart', onDocumentTouchStartCapture, {
        capture: true,
        passive: true
      });
    }
  };
};

export { init }